import axios from "axios";

// const axiosClient = axios.create({
//   baseURL: `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}`,
//   headers: {
//     Accept: "application/json",
//     "Content-Type": "application/json",
//     Authorization: `Bearer ${localStorage.getItem("access-token")}`,
//   },
// });

let axiosClient = null;

export const createAxios = (token) => {
  axiosClient = axios.create({
    baseURL: `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}`,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  axiosClient.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      let res = error.response;
      if (res.status === 401) {
        window.location.href = "./";
      }
      // console.error(`Looks like there was a problem. Status Code: ` + res.status);
      return Promise.reject(error);
    }
  );
};

export async function fetchData(params, callback) {
  try {
    const res = await axiosClient.post("/videodownloadqueue/all", params);
    callback(200, res.data.data);
  } catch (error) {
    handleError(error, callback);
  }
}

export async function createQueue(params, callback) {
  try {
    const res = await axiosClient.post("/videodownloadqueue/create", params);
    res.data.params = {
      queue_status: params.queue_status,
      hwid: params.hwid,
      filename: params.filename,
      camera_source: params.camera_source,
    };
    callback(200, res);
  } catch (error) {
    handleError(error, callback);
  }
}

export async function createQueues(params, callback) {
  try {
    const res = await axiosClient.post(
      "/videodownloadqueue/create-multiple",
      params
    );
    res.data.params = {
      queue_status: params.queue_status,
      hwid: params.hwid,
      filename: params.filename,
    };
    callback(200, res);
  } catch (error) {
    handleError(error, callback);
  }
}

export async function cancelQueue(params, callback) {
  try {
    const res = await axiosClient.patch(
      "/videodownloadqueue/cancel/" + params.id,
      params
    );
    res.data.params = {
      queue_status: params.queue_status,
      hwid: params.hwid,
      filename: params.filename,
    };
    callback(200, res);
  } catch (error) {
    handleError(error, callback);
  }
}

export async function reQueue(params, callback) {
  try {
    const res = await axiosClient.patch(
      "/videodownloadqueue/requeue/" + params.id,
      params
    );
    res.data.params = {
      queue_status: params.queue_status,
      hwid: params.hwid,
      filename: params.filename,
    };
    callback(200, res);
  } catch (error) {
    handleError(error, callback);
  }
}

export async function deleteQueue(params, callback) {
  try {
    const res = await axiosClient.delete(
      "/videodownloadqueue/delete/" + params.id,
      params
    );
    res.data.params = {
      hwid: params.hwid,
      filename: params.filename,
      queue_status: params.queue_status,
    };
    callback(200, res);
  } catch (error) {
    handleError(error, callback);
  }
}

export async function fetchVechicles(params, callback) {
  try {
    const res = await axiosClient.post(
      "/videodownloadqueue/getvehicleslist",
      params
    );
    callback(200, res);
  } catch (error) {
    handleError(error, callback);
  }
}

export async function fetchAllConnection(callback) {
  try {
    const allconnect = await axios.get(
      `https://${process.env.REACT_APP_WEBSOCKET}/getAllConnection?idprocess=web` +
      new Date().getTime()
    );
    callback(allconnect.data.message.split(","));
  } catch (error) {
    handleError(error, callback);
  }
}

export async function fetchDeviceProcess(imei, callback) {
  try {
    const allconnect = await axios.get(
      `https://${process.env.REACT_APP_WEBSOCKET}/getDeviceProcessByImei?imei=${imei}`
    );
    callback(allconnect.data);
  } catch (error) {
    handleError(error, callback);
  }
}

export async function getpubliclink(params, callback) {
  try {
    const res = await axiosClient.post(
      "/videodownloadqueue/getpubliclink",
      params
    );
    callback(200, res);
  } catch (error) {
    handleError(error, callback);
  }
}

export async function updateAutoDownload(id) {
  try {
    await axiosClient.patch(`/videodownloadqueue/updateautodownload/${id}`, {});
  } catch (error) {
    handleError(error);
  }
}

const handleError = (error, callback) => {
  // Handle error here or pass it to callback

  console.error("API Error:", error);
  //   callback(error.response?.status, error.response?.data);
};

export async function createLog(params) {
  const payload = {
    imei: params.hwid,
    cmd_type: "DownloadVideo",
    vehicle_id: params.vehicle_id,
    user_id: `${params.user_id}`,
    ip_address: params.ip_address,
    camera_source: params.camera_source,
    filename: params.filename,
    filesize: params.file_size,
    date_time_select: params.date_time_select,
    webconnect_id: params.webconnect_id,
  };

  try {
    await axios.post(
      `${process.env.REACT_APP_WEBSOCKET_LOG}/api/websocket/createlogs`,
      payload,
      {
        auth: {
          username: "websocketLivestream",
          password: "66e49accea2f72036676811d72aa6d51",
        },
      }
    );
  } catch (error) {
    console.error(error);
  }
}
